import type { RatParam } from '../types/analytics';

// Mapping regex representing path patterns to RAT keys
export const PATH_TO_RAT: { [key: string]: string | { dated: string; undated: string } } = {
  '^.*?/hotel_list(?:$|[/?].*)': {
    dated: 'search:search_results_dated_list',
    undated: 'search:search_results_undated_list',
  },
  '^.*?/hotel_info_item(?:$|[/?].*)': {
    dated: 'hotel:rooms_and_plans_dated_list',
    undated: 'hotel:rooms_and_plans_undated_list',
  },
  '^.*?/hotel_booking/step1(?:$|[/?].*)': 'booking:guest_details_form',
  '^.*?/hotel_booking/step2(?:$|[/?].*)': 'booking:payment_details_form',
  '^.*?/hotel_booking/step3(?:$|[/?].*)': 'booking:confirmation_message',
  '^.*?/explorer(?:$|[/?].*)': 'area:search_form',
  '^.*?/hotel_modification/step1(?:$|[/?].*)': 'modification:change_booking_dates_form',
  '^.*?/hotel_modification/step2(?:$|[/?].*)': 'modification:pre_modification_summary',
  '^.*?/hotel_modification/step3(?:$|[/?].*)': 'modification:confirmation_message',
  '^.*?/hotel_cancellation(?:$|[/?].*)': 'cancellation:pre_cancellation_details',
  '^/(?:[A-Za-z]{3}/[a-z]{2}-[a-z]{2})?/?$': 'top:search_form', // matching '/' or '/xxx/xx-xx' or '/xxx/xx-xx/'
  '^.*?/top/?$': 'top:search_form',
};

export const RAT_PAGE_TYPE_OBJ = {
  top: {
    pageType: 'top',
    siteSection: 'top',
    parentName: 'top:search_form',
  },
  topCampaign: {
    pageType: 'top',
    siteSection: 'top',
    parentName: 'top',
  },
  providerListUndated: {
    pageType: 'search',
    siteSection: 'search',
    parentName: 'search:search_results_undated_list',
  },
  providerListDated: {
    pageType: 'search',
    siteSection: 'search',
    parentName: 'search:search_results_dated_list',
  },
  couponSearch: {
    pageType: 'top',
    siteSection: 'account_coupons',
    parentName: 'account_coupons:coupons_list',
  },
  area: {
    pageType: 'top',
    siteSection: 'area',
    parentName: 'area:search_form',
  },
  rateplan: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'area:search_form',
  },
  providerInfoUndated: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'hotel:rooms_and_plans_undated_list',
  },
  providerInfoDated: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'hotel:rooms_and_plans_dated_list',
  },
  modification: {
    pageType: 'top',
    siteSection: 'modification',
    parentName: 'modification:change_booking_dates_form',
  },
  modificationStep2: {
    pageType: 'top',
    siteSection: 'modification',
    parentName: 'modification:pre_modification_summary',
  },
  modificationStep3: {
    pageType: 'top',
    siteSection: 'modification',
    parentName: 'modification:confirmation_message',
  },
  reviewList: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'hotel:reviews_list',
  },
  vacancyCalendar: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'area:search_form',
  },
  vacancyCalendarUndated: {
    pageType: 'shop_item',
    siteSection: 'hotel',
    parentName: 'area:search_form',
  },
  reservationListCampagin: {
    pageType: 'top',
    siteSection: 'reservations_details',
    parentName: 'reservations_details',
  },
  authRequest: {
    pageType: 'cart_checkout',
    siteSection: 'booking',
    parentName: 'booking:non_member_email_form',
  },
  bookingStep1: {
    parentName: 'booking:guest_details_form',
    pageType: 'cart_checkout',
    siteSection: 'booking',
  },
  bookingStep2: {
    parentName: 'booking:payment_details_form',
    pageType: 'cart_checkout',
    siteSection: 'booking',
  },
  bookingStep3: {
    pageType: 'cart_checkout',
    siteSection: 'booking',
    parentName: 'booking:confirmation_message',
  },
  bookingCampaign: {
    pageType: 'cart_checkout',
    siteSection: 'booking',
    parentName: 'booking',
  },
  bookmarkList: {
    pageType: 'top',
    siteSection: 'account_bookmarks',
    parentName: 'account_bookmarks:bookmarks_list',
  },
  cancelStep1: {
    pageType: 'top',
    siteSection: 'cancellation',
    parentName: 'cancellation:pre_cancellation_details',
  },
  couponDetail: {
    pageType: 'top',
    siteSection: 'account_coupons',
    parentName: 'account_coupons:coupons_detail',
  },
  guestReviewDetail: {
    pageType: 'top',
    siteSection: 'account_reviews',
    parentName: 'account_reviews:review_details',
  },
  guestReviewList: {
    pageType: 'top',
    siteSection: 'account_reviews',
    parentName: 'account_reviews:reviews_list',
  },
  loginOrGuest: {
    pageType: 'my_account',
    siteSection: 'my_account',
    parentName: 'log_in_or_continue_as_guest_menu_popup',
  },
  notificationDetails: {
    pageType: 'top',
    siteSection: 'account_notifications',
    parentName: 'account_notifications:notification_details',
  },
  notifications: {
    pageTpe: 'top',
    siteSection: 'account_notifications',
    parentName: 'account_notifications:notifications_list',
  },
  postReview: {
    pageType: 'top',
    siteSection: 'account_reviews',
    parentName: 'account_reviews:post_review_form',
  },
  mailSubscription: {
    pageType: 'top',
    siteSection: 'account_settings',
    parentName: 'account_settings:mail_magazine_authentication',
  },
};

export const ratPropsToParams: RatParam = {
  generic: [
    {
      prop: 'siteSection',
      id: 'ratSiteSection',
    },
    {
      prop: 'pageType',
      id: 'ratPageType',
    },
    {
      prop: 'pageName',
      id: 'ratPageName',
    },
    {
      prop: 'reservationId',
      id: 'ratReservationId',
    },
    {
      prop: 'shopId',
      id: 'ratShopId',
    },
    {
      prop: 'searchQuery',
      id: 'ratSearchQuery',
    },
    {
      prop: 'searchCondition',
      id: 'ratSearchCondition',
    },
    {
      prop: 'shopIdList',
      id: 'ratShopIdList',
    },
    {
      prop: 'itemIds',
      id: 'ratItemId',
    },
    {
      prop: 'areaName',
      id: 'ratArea',
    },
    {
      prop: 'orderPaymentMethod',
      id: 'ratPayment',
    },
    {
      prop: 'abTestingPattern',
      id: 'ratAbTest',
    },
    {
      prop: 'abTestingVariants',
      id: 'ratTestTargeting',
    },
    {
      prop: 'providerGenre',
      id: 'ratItemGenre',
    },
    {
      prop: 'topProviderFeatures',
      id: 'ratTag',
    },
    {
      prop: 'topRoomPlanFeatures',
      id: 'ratItemTag',
    },
    {
      prop: 'checkoutStage',
      id: 'ratCheckout',
    },
    {
      prop: 'itemRatePlanPrice',
      id: 'ratPrice',
    },
    {
      prop: 'searchConditionsAndOr',
      id: 'ratOrAnd',
    },
  ],
  custom: [
    {
      prop: 'numOfAdults',
      id: 'number_of_adult_guests',
    },
    {
      prop: 'numOfChildren',
      id: 'number_of_child_guests',
    },
    {
      prop: 'numOfGuest',
      id: 'number_of_guests',
    },
    {
      prop: 'salesPromotions',
      id: 'sales_promotion_ids',
    },
    {
      prop: 'childrenAges',
      id: 'child_guest_ages',
    },
    {
      prop: 'noOfRooms',
      id: 'number_of_rooms',
    },
    {
      prop: 'isBookable',
      id: 'is_bookable',
    },
    {
      prop: 'propertyCountry',
      id: 'area_country',
    },
    {
      prop: 'propertyCity',
      id: 'area_city',
    },
    {
      prop: 'hotelRegion',
      id: 'area_province',
    },
    {
      prop: 'propertyDistrict',
      id: 'area_district',
    },
    {
      prop: 'placeName',
      id: 'place_name',
    },
    {
      prop: 'couponSalesPromotion',
      id: 'gotten_coupon_sales_promotion_id',
    },
    {
      prop: 'providerCategory',
      id: 'provider_category',
    },
    {
      prop: 'providerFacilities',
      id: 'provider_facilities',
    },
    {
      prop: 'reviewId',
      id: 'review_id',
    },
    {
      prop: 'searchFilters',
      id: 'search_condition',
    },
    {
      prop: 'totalSearchResults',
      id: 'total_results',
    },
    {
      prop: 'searchHits',
      id: 'hits',
    },
    {
      prop: 'searchSortType',
      id: 'sort',
    },
    {
      prop: 'searchPageNumber',
      id: 'rpgn',
    },
    {
      prop: 'isSearchFilterApplied',
      id: 'fa',
    },
    {
      prop: 'gspReqId',
      id: 'gsp_reqid',
    },
    {
      prop: 'areaId',
      id: 'areaid',
    },
    {
      prop: 'mapLatitude',
      id: 'latitude',
    },
    {
      prop: 'mapLongitude',
      id: 'longitude',
    },
    {
      prop: 'searchConditionId',
      id: 'scondid',
    },
    {
      prop: 'mapZoom',
      id: 'mapzoom',
    },
    {
      prop: 'isJapanQuality',
      id: 'japan_quality',
    },
  ],
  conversion: [
    {
      prop: 'purchaseGms',
      id: 'purchase_gms',
    },
    {
      prop: 'purchaseOrder',
      id: 'purchase_order',
    },
    {
      prop: 'reserveRoom',
      id: 'reserve_room',
    },
    {
      prop: 'reserveNum',
      id: 'reserve_num',
    },
    {
      prop: 'reviewPost',
      id: 'review_post',
    },
    {
      prop: 'cancel',
      id: 'cancel',
    },
    {
      prop: 'mailMagSubscribe',
      id: 'mailmag_subscribe',
    },
    {
      prop: 'getCouponItem',
      id: 'get_coupon_item',
    },
    {
      prop: 'itemViewCount',
      id: 'item_view',
    },
    {
      prop: 'isOnCartAdd',
      id: 'cart_add',
    },
  ],
};

// string that pass to the element binding RAT by attribute [data-ratParam]
export const ratParamsForBS =
  'ratSiteSection, ratPageName, ratPageLayout, ratCountryCode, ratCurrencyCode, ratLanguage, ratShopId, ratItemId';
